export default {
	CANVAS: 'canvas',
	SVG: 'svg',
}
